module.exports = __webpack_public_path__ + "media/day/362-f1fc1c5b.svg";